import { render, staticRenderFns } from "./WarehousePalletMaintenance.vue?vue&type=template&id=6f23e130&"
import script from "./WarehousePalletMaintenance.vue?vue&type=script&lang=js&"
export * from "./WarehousePalletMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports